import {
  GetFinalityLogsRequest,
  GetFinalityLogsResponse
} from "../../../domain/repositories/FinalityRepository";

export const TRIGGER_GET_FINALITY_LOGS = 'GET_FINALITY_LOGS.TRIGGER';
export const GET_FINALITY_LOGS_PENDING = 'GET_FINALITY_LOGS.PENDING';
export const GET_FINALITY_LOGS_SUCCESS = 'GET_FINALITY_LOGS.SUCCESS';
export const GET_FINALITY_LOGS_ERROR = 'GET_FINALITY_LOGS.ERROR';

export const RESET_GET_FINALITY_LOGS = 'GET_FINALITY_LOGS.RESET';

export interface TriggerGetFinalityLogs {
  type: typeof TRIGGER_GET_FINALITY_LOGS;
  payload: {
    request: GetFinalityLogsRequest;
  };
}

export interface GetFinalityLogsPending {
  type: typeof GET_FINALITY_LOGS_PENDING;
}

export interface GetFinalityLogsSuccess {
  type: typeof GET_FINALITY_LOGS_SUCCESS;
  payload: {
    response: GetFinalityLogsResponse;
  }
}

export interface GetFinalityLogsError {
  type: typeof GET_FINALITY_LOGS_ERROR;
}

export interface ResetGetFinalityLogs {
  type: typeof RESET_GET_FINALITY_LOGS;
}


export type GetFinalityLogsActionType =
  | TriggerGetFinalityLogs
  | GetFinalityLogsPending
  | GetFinalityLogsSuccess
  | GetFinalityLogsError
  | ResetGetFinalityLogs;


export interface GetFinalityLogsState {
  getFinalityLogsPending: boolean;
  getFinalityLogsError: boolean;
  getFinalityLogsResponse: GetFinalityLogsResponse | null;
}